import { mapGetters } from "vuex";

export default {
	name: "AccountButtons",
	computed: {
		...mapGetters("account", ["isLoggedIn"]),
	},
};
